<template>
  <div id="page-title">
    <div
      v-if="type == 'default'"
      class="default-page-title"
    >
      <ul class="w1200">
        <li>
          <router-link :to="LinkTypeCode.Home">
            {{ firsttext }}
            <span>></span>
          </router-link>
        </li>
        <li
          v-for="(item, i) in text"
          :key="i"
        >
          {{ item }}
          <span v-if="i != text.length - 1">></span>
        </li>
      </ul>
    </div>
    <div
      v-else
      class="search-page-title"
    >
      <ul class="w1200">
        <li>
          <div class="first">
            <span>{{ firsttext }}</span>
          </div>
          <span>></span>
        </li>
        <li
          v-for="(item, i) in text"
          :key="i"
        >
          <div
            class="title"
            @click="clearTitle(item)"
          >
            <span>{{ item }}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { LinkTypeCode } from '../dictionary/base.js'
export default {
  name: 'PageTitle',
  props: {
    type: {
      type: String,
      default: 'default'
    },
    text: {
      type: Array,
      default() {
        return []
      }
    },
    firsttext: {
      type: String,
      default: '首页'
    }
  },
  data() {
    return {
      LinkTypeCode
    }
  },
  methods: {
    clearTitle(item) {
      this.$emit('clear', item)
    }
  }
}
</script>
<style lang="less" scoped>
#page-title {
  .default-page-title {
    margin-top: 16px;

    ul {
      margin: 0 auto;
      text-align: left;

      > li {
        display: inline-block;
        color: #999999;
        font-size: 14px;
        cursor: pointer;

        > a:link {
          font-size: 14px;
          color: #999999;
          text-decoration: none;
        }

        > a:visited {
          font-size: 14px;
          color: #999999;
          text-decoration: none;
        }

        > a:hover {
          font-size: 14px;
          color: #999999;
          text-decoration: none;
        }

        > a > span {
          display: inline-block;
          margin: 0 4px;
        }

        > span {
          display: inline-block;
          margin: 0 4px;
        }

        &:last-child {
          color: #222222;
        }
      }
    }
  }

  .search-page-title {
    margin-top: 20px;

    ul {
      margin: 0 auto;
      text-align: left;
      li:hover {
        > .title {
          &:last-child {
            > span::after {
              background: #0049b8 url("../assets/goods/a-cha.png") no-repeat
                center;
              content: "";
              background-size: 10px 10px;
              width: 29px;
              height: 24px;
              position: absolute;
              top: 0px;
              right: 0px;
            }
          }
        }
      }
      > li {
        display: inline-block;
        color: rgba(153, 153, 153, 1);
        height: 24px;
        position: relative;

        // >span {
        //   margin: 0 10px 0 10px;
        // }
        margin: 0 5px 0 5px;

        > .first {
          display: inline-block;
          line-height: 24px;
          font-size: 14px;
          border-radius: 2px;
          padding: 0 10px 0 0;
        }

        > .title {
          display: inline-block;
          line-height: 24px;
          font-size: 14px;
          border-radius: 2px;
          box-shadow: 0 0 0 1px rgba(190, 190, 190, 1);
          padding: 0 40px 0 10px;
          cursor: pointer;

          > span::after {
            background: url("../assets/goods/cha.png") no-repeat;
            content: "";
            background-size: cover;
            width: 10px;
            height: 10px;
            position: absolute;
            top: 9px;
            margin-left: 20px;
          }

          &:first-child {
            box-shadow: 0 0 0 0;
          }

          &:last-child {
            color: #0f6ee9;
            display: inline-block;
            border-radius: 2px;
            box-shadow: 0 0 0 1px #0f6ee9;

            > span::after {
              background: #0f6ee9 url("../assets/goods/a-cha.png") no-repeat
                center;
              content: "";
              background-size: 10px 10px;
              width: 29px;
              height: 24px;
              position: absolute;
              top: 0px;
              right: 0px;
            }
          }
        }
      }
    }
  }
}
</style>
